import React from "react"
import { PieAmchartSeeker } from "@ui-seeker/core"
import { AppResultsSkeleton } from "@components"


export default function SearchAnalyticsPieChart({ data, isDateRangeLoading }) {

	if (isDateRangeLoading) return <AppResultsSkeleton chart height={318}/>
	
	return <PieAmchartSeeker
		rootID="SearchAnalyticsPieChart"
		data={data.percentageSite}
		title="Number of searches by Site"
		series={[{
			yField: 'site',
			xField: "percentage",
			innerRadius: 60,
		}]}
		sx={{ height: 318 }}
		chartProps={{
			enabledPDF: false,
			// legend under the donut, as on the Main Page, so the donut never runs out of width
			root: {
				colors: data?.siteSeries?.map(({ color }) => color)
			},
			legend: {
				verticalLayout: false,
				labels: {
					width: 130,
					maxWidth: 130,
					oversizedBehavior: "truncate",
				},
				valueLabels: {
					width: 60,
					textAlign: "right"
				}
			}
		}}

	/>
}